/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type allocations_AllocationResponse = {
    /**
     * AgeTypeCode defines the age type (BABY or CHILD)
     */
    age_type_code: string;
    /**
     * ChildFirstname for display purposes
     */
    child_firstname: string;
    /**
     * ChildID references the child
     */
    child_id: string;
    /**
     * ChildLastname for display purposes
     */
    child_lastname: string;
    /**
     * ContractID references the contract
     */
    contract_id: string;
    /**
     * ContractNumber for display purposes
     */
    contract_number: string;
    /**
     * Audit fields
     */
    created_at: string;
    created_by: string;
    friday_services: Array<string>;
    /**
     * FromDate when the allocation begins
     */
    from_date: string;
    /**
     * GroupID references the group
     */
    group_id: string;
    /**
     * GroupName for display purposes
     */
    group_name: string;
    /**
     * GroupType for display purposes
     * Enum: STANDARD,SMALL,LARGE,SPECIAL
     */
    group_type?: allocations_AllocationResponse.group_type;
    /**
     * ID is the unique identifier
     */
    id: string;
    /**
     * Weekday services
     */
    monday_services: Array<string>;
    saturday_services: Array<string>;
    sunday_services: Array<string>;
    thursday_services: Array<string>;
    /**
     * ToDate when the allocation ends
     */
    to_date: string;
    tuesday_services: Array<string>;
    updated_at: string;
    updated_by?: string;
    /**
     * Warnings from business logic validations
     */
    warnings?: Array<string>;
    wednesday_services: Array<string>;
};
export namespace allocations_AllocationResponse {
    /**
     * GroupType for display purposes
     * Enum: STANDARD,SMALL,LARGE,SPECIAL
     */
    export enum group_type {
        STANDARD = 'STANDARD',
        SMALL = 'SMALL',
        LARGE = 'LARGE',
        SPECIAL = 'SPECIAL',
    }
}

